import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";

const date = new Date();

const day = date.getDate();
const month = date.getMonth();
const year = date.getFullYear();

export const COLUMNS_DATA = ({
  deleteRow,
  editEmployee,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  AddEmployeeCategorys,
  AddFranchiseDetails,
  AddRolesDetail,
  ViewRolesDetail,
  handleOpenChangePassModal,
  handleOpenSendNotificationModal,
  handleOpenAllocateZoneModal,
  viewZoneModal,
  PatientCoordinatorRate,
  ViewPatientCoordinatorRate,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Agent Name",
    accessor: "agent_name",
    disableSortBy: true,
  },
  {
    Header: "Mobile Number",
    accessor: "mobile",
    disableSortBy: true,
  },
  {
    Header: "Email Address",
    accessor: "email",
    disableSortBy: true,
  },
  {
    Header: "Home Address",
    accessor: "address",
    disableSortBy: true,
  },
  {
    Header: "Joining Date",
    accessor: "joining_date",
    disableSortBy: true,
  },
  {
    Header: "Is Working",
    accessor: "is_working",
    disableSortBy: true,
  },
  {
    Header: "With Effect From",
    accessor: "with_effect_from",
    disableSortBy: true,
  },
  {
    Header: "Most Recent",
    accessor: "most_recent",
    disableSortBy: true,
  },
  {
    Header: "Father's Name",
    accessor: "father_name",
    disableSortBy: true,
  },
  {
    Header: "Mother's Name",
    accessor: "mother_name",
    disableSortBy: true,
  },
  {
    Header: "Date of Birth",
    accessor: "dob",
    disableSortBy: true,
  },
  {
    Header: "ESI Number",
    accessor: "esi_no",
    disableSortBy: true,
  },
  {
    Header: "PAN Number",
    accessor: "pan_no",
    disableSortBy: true,
  },
  {
    Header: "Qualification",
    accessor: "qualification",
    disableSortBy: true,
  },
  {
    Header: "EPF Number",
    accessor: "epf_no",
    disableSortBy: true,
  },
  {
    Header: "Passport Number",
    accessor: "passport_no",
    disableSortBy: true,
  },
  {
    Header: "Blood Group",
    accessor: "blood_group",
    disableSortBy: true,
  },
  {
    Header: "Username",
    accessor: "username",
    disableSortBy: true,
  },

  // More Button
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>

          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editEmployee(cell.row.original)}
              >
                Edit
              </button>
            </li>
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}

            <li>
              <button
                className="dropdown-item"
                onClick={() => PatientCoordinatorRate(cell.row.original)}
              >
                Patient Coordinator Rate
              </button>
            </li>

            <li>
              <button
                className="dropdown-item"
                onClick={() => ViewPatientCoordinatorRate(cell.row.original)}
              >
                View Patient Coordinator Rate
              </button>
            </li>

            {/* <li>
              <button
                className="dropdown-item"
                onClick={() => AddRolesDetail(cell.row.original)}
              >
                Add & View Roles
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => AddFranchiseDetails(cell.row.original)}
              >
                Add Franchise
              </button>
              <button
                className="dropdown-item"
                onClick={() => AddEmployeeCategorys(cell.row.original)}
              >
                Add Employee Category
              </button>
            </li> */}
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleOpenChangePassModal(cell.row.original)}
              >
                Reset Password
              </button>
            </li>
            {/* <li>
              <button
                className="dropdown-item"
                onClick={() =>
                  handleOpenSendNotificationModal(cell.row.original)
                }
              >
                Send Notification
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => handleOpenAllocateZoneModal(cell.row.original)}
              >
                Allocate Zone
              </button>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => viewZoneModal(cell.row.original)}
              >
                View Zone
              </button>
            </li> */}
          </ul>
        </>
      );
    },
  },
];

export const EMPLOYEE_VIEW_ROLES_COLUMNS_DATA = ({
  deleteRowRole,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
}) => [
  {
    Header: "S.No",
    accessor: (row, index) => index + 1,
    id: "serial_number",
    disableSortBy: true,
  },
  {
    Header: "Employee Role Id",
    accessor: "role_obj.role_id",
    disableSortBy: true,
  },
  {
    Header: "Employee Role Name",
    accessor: "role_obj.role_name",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRowRole(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];

export const EMPLOYEE_VIEW_ALLOCATE_ZONE_COLUMNS_DATA = ({
  filters,
  deleteRowZone,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
}) => [
  {
    Header: "S.No",
    accessor: (row, index) => index + 1,
    id: "serial_number",
    disableSortBy: true,
  },
  {
    Header: "Employee Code Id",
    accessor: "employee_obj.employee_code_id",
    disableSortBy: true,
  },
  {
    Header: "Employee Name",
    accessor: "employee_obj.employee_name",
    disableSortBy: true,
  },
  {
    Header: "Zone Name",
    accessor: "zone_obj.zone_name",
    disableSortBy: true,
  },
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRowZone(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];
export const OPTIONS = [
  { key: "department", value: "Department" },
  { key: "employee_name", value: "Employee Name" },
  { key: "branch", value: "Branch" },
  { key: "designation", value: "Designation" },
  { key: "mobile", value: "Mobile" },
  { key: "email", value: "Email" },
  { key: "salary", value: "Salary" },
  { key: "address", value: "Address" },
  { key: "joining_date", value: "Joining Date" },
  { key: "is_working", value: "Is Working" },
  { key: "employee_id", value: "Employee ID" },
  { key: "zone", value: "Zone" },
  { key: "office_address", value: "Office Address" },
  { key: "father_name", value: "Father's Name" },
  { key: "mother_name", value: "Mother's Name" },
  { key: "dob", value: "Date Of Birth" },
  { key: "esi_no", value: "ESI Number" },
  { key: "pan_no", value: "PAN Number" },
  { key: "qualification", value: "Qualification" },
  { key: "epf_no", value: "EPF Number" },
  { key: "passport_no", value: "Passport Number" },
  { key: "blood_group", value: "Blood Group" },
  { key: "user_type", value: "User Type" },
  { key: "username", value: "Username" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

const IS_WORKING_OPTIONS = [
  { key: true, value: "Yes" },
  { key: false, value: "No" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];

export const EMPLOYEE_FORM_CONFIG = (rowData) => {
  return [
    {
      label: "Agent Name",
      type: "input-text",
      name: "agent_name",
      defaultValue: rowData?.agent_name || "",
      validations: { maxLength: 255, required: true },
    },
    {
      label: "Mobile Number",
      type: "input-text",
      name: "mobile",
      defaultValue: rowData?.mobile || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Email ID",
      type: "input-text",
      name: "email",
      defaultValue: rowData?.email || "",
      validations: { maxLength: 255, required: true },
    },
    {
      label: "Address",
      type: "input-text",
      name: "address",
      defaultValue: rowData?.address || "",
      validations: { maxLength: 255, required: false },
    },
    // {
    //   label: "Joining Date",
    //   type: "input-date",
    //   name: "joining_date",
    //   defaultValue: rowData?.joining_date || "",
    //   validations: { required: false },
    // },
    {
      label: "Is Working",
      type: "select",
      name: "is_working",
      defaultValue: rowData?.is_working ?? true,
      options: [
        { key: true, value: true, label: "Yes" },
        { key: false, value: false, label: "No" },
      ],
      validations: { required: false },
    },
    // {
    //   label: "With Effect From",
    //   type: "input-date",
    //   name: "with_effect_from",
    //   defaultValue: rowData?.with_effect_from || "",
    //   validations: { required: false },
    // },
    // {
    //   label: "Most Recent",
    //   type: "select",
    //   name: "most_recent",
    //   defaultValue: rowData?.most_recent ?? true,
    //   options: [
    //     { key: true, value: true, label: "Yes" },
    //     { key: false, value: false, label: "No" },
    //   ],
    //   validations: { required: false },
    // },
    {
      label: "Username",
      type: "input-text",
      name: "username",
      defaultValue: rowData?.username || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Password",
      type: "input-password",
      name: "password",
      defaultValue: rowData?.password || "",
      disabled: rowData ? true : false,
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Father's Name",
      type: "input-text",
      name: "father_name",
      defaultValue: rowData?.father_name || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Mother's Name",
      type: "input-text",
      name: "mother_name",
      defaultValue: rowData?.mother_name || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Date of Birth",
      type: "input-date",
      name: "dob",
      defaultValue: rowData?.dob || "",
      validations: { required: false },
    },
    {
      label: "ESI Number",
      type: "input-text",
      name: "esi_no",
      defaultValue: rowData?.esi_no || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "PAN Number",
      type: "input-text",
      name: "pan_no",
      defaultValue: rowData?.pan_no || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Qualification",
      type: "input-text",
      name: "qualification",
      defaultValue: rowData?.qualification || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "EPF Number",
      type: "input-text",
      name: "epf_no",
      defaultValue: rowData?.epf_no || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Passport Number",
      type: "input-text",
      name: "passport_no",
      defaultValue: rowData?.passport_no || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Blood Group",
      type: "input-text",
      name: "blood_group",
      defaultValue: rowData?.blood_group || "",
      validations: { maxLength: 255, required: false },
    },
    {
      label: "Zone",
      type: "select",
      name: "zone_id",
      defaultValue: rowData?.zone_id || "",
      options: [],
      validations: {
        required: true,
      },
    },
  ];
};

export const ADD_FRANCHISE_CONFIG = (rowData) => [
  {
    label: "Franchise",
    type: "select",
    name: "franchise_dropdown",
    defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const ADD_ROLES_CONFIG = (rowData) => [
  {
    label: "Roles",
    type: "select",
    name: "multi_roles",
    // defaultValue: rowData?.franchise_id || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const ADD_EMPLOYEE_CATEGORY = (rowData) => {
  return [
    {
      label: "Already Exists",
      type: "select",
      name: "already_exists",
      defaultValue: rowData ? rowData[0]?.employee_code_id : "",
      options: [],
      validations: {
        required: true,
      },
    },
    {
      label: "Employee Category",
      type: "select",
      name: "employee_category",
      defaultValue: rowData ? rowData[0]?.id : "",
      options: [],
      validations: {
        required: true,
      },
    },
  ];
};

export const SEND_NOTIFICATION_CATEGORY = (rowData) => {
  return [
    {
      label: "Notification Title",
      type: "input-text",
      name: "title",
      defaultValue: rowData?.title,
      options: [],
      validations: {
        required: true,
      },
    },
    {
      label: "Message",
      type: "text-area",
      name: "comments",
      defaultValue: rowData?.message,
      options: [],
      validations: {
        required: true,
      },
    },
  ];
};

export const ALLOCATE_BARCODE = (rowData) => {
  return [
    {
      label: "Zone",
      type: "select",
      name: "multiple_zone",
      defaultValue: rowData?.id,
      options: [],
      validations: {
        required: true,
      },
    },
  ];
};

export const COORDINATOR_RATES_FORM_CONFIG = (rowData) => [
  {
    label: "Lab Department",
    type: "select",
    name: "lab_department",
    defaultValue: rowData?.lab_department_obj?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  {
    label: "Package",
    type: "select",
    name: "package_id",
    defaultValue: rowData?.package_id?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  {
    label: "Investigation",
    type: "select",
    name: "investigation_name",
    defaultValue: rowData?.investigation_id?.id || "",
    options: [],
    validations: {
      required: false,
    },
  },
  {
    label: "IP Percentage",
    type: "input-number",
    name: "ip_percentage",
    defaultValue: rowData?.ip_percentage || "",
    validations: {
      required: true,
    },
  },
];

export const COLUMNS_DATA_IP_RATES = ({
  deleteRow,
  editDoctors,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  viewIPRates,
  editInvestigationComment,
}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Department Name",
    accessor: "lab_department_obj.department",
    disableSortBy: true,
  },
  {
    Header: "Package Name",
    accessor: "package_id.package_name",
    disableSortBy: true,
  },
  {
    Header: "Investigation Name",
    accessor: "investigation_obj.investigation_name",
    disableSortBy: true,
  },
  {
    Header: "IP Percentage",
    accessor: "ip_percentage",
    disableSortBy: true,
  },
  // {
  //   Header: "",
  //   accessor: "ids",
  //   disableSortBy: true,
  //   Cell: ({ cell }) => {
  //     return (
  //       <>
  //         <button
  //           disabled={!filters.is_active}
  //           className={classNames("btn dropdown-toggle", {
  //             "btn-primary": filters.is_active,
  //             "btn-secondary": !filters.is_active,
  //           })}
  //           type="button"
  //           data-bs-toggle="dropdown"
  //           aria-expanded="false"
  //         >
  //           More...
  //         </button>
  //         <ul className="dropdown-menu">
  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Edit
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => viewIPRates(cell.row.original)}
  //             >
  //               View IP Rates
  //             </button>
  //           </li>

  //           <li>
  //             <button
  //               className="dropdown-item"
  //               onClick={() => editDoctors(cell.row.original)}
  //             >
  //               Add IP Rates
  //             </button>
  //           </li>

  //           {isSuperFranchise != 1 &&
  //             isFranchiseEmployee != 1 &&
  //             isSubFranchise != 1 && (
  //               <li>
  //                 <button
  //                   className="dropdown-item"
  //                   onClick={() => deleteRow(cell.row.original)}
  //                 >
  //                   Delete
  //                 </button>
  //               </li>
  //             )}
  //         </ul>
  //       </>
  //     );
  //   },
  // },
  {
    Header: "",
    accessor: "ids",
    disableSortBy: true,
    Cell: ({ cell }) => {
      return (
        <>
          <button
            disabled={!filters.is_active}
            className={classNames("btn dropdown-toggle", {
              "btn-primary": filters.is_active,
              "btn-secondary": !filters.is_active,
            })}
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More...
          </button>
          <ul className="dropdown-menu">
            <li>
              <button
                className="dropdown-item"
                onClick={() => editInvestigationComment(cell.row.original)}
              >
                Edit
              </button>
            </li>
            {isSuperFranchise != 1 &&
              isFranchiseEmployee != 1 &&
              isSubFranchise != 1 && (
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => deleteRow(cell.row.original)}
                  >
                    Delete
                  </button>
                </li>
              )}
          </ul>
        </>
      );
    },
  },
];

export const FILTER_DEFINITIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
